export class UserExtensions {
  static generateInitials(firstName: string, lastName: string): string {
    let initials = firstName?.length ? firstName[0] : '';

    if (lastName?.length) {
      const lnUpper = lastName.match(/[A-Z]/);
      initials += lnUpper ?? lastName[0];
    }
    return initials;
  }
}
